
class Login extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.recoveryForm = this.element.querySelector("#ForgotPass");
        this.loginForm = this.element.querySelector("#logIn");

        if (window.location.href.indexOf("recover") != -1){
            this.openRecover();
        }

        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="toggle-recovery"]',
            this.openRecover.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="toggle-login"]',
            this.openLogin.bind(this)
        );
     
      this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    }

    submitRegistration(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const _this = this;
      const registrationEndpoint = '/account';
    
      // Create the request body with the registration data
      const requestBody = {
        'customer': {
          'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
          'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
          'email': this.element.querySelector('#register #RegisterForm-email').value,
          'password': this.element.querySelector('#register #RegisterForm-password').value
        }
      };
    
      /*event.target.querySelector('.ButtonText').style.visibility = "hidden";
      event.target.querySelector('.itemLoader').classList.add('is-visible');*/
    
      // Send the AJAX request
      (async function() {
        try {

          if (window.hcaptcha) {
            const captchaToken = await window.hcaptcha.execute(null, { async: true });
            requestBody['h-captcha-response'] = captchaToken.response;
          }
          const response = await fetch(registrationEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
          });
    
          const responseText = await response.text();
    
          if (responseText.indexOf('registerErrors') !== -1) {
            console.log('Error occurred during registration');
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseText;
    
            const errorElem =  _this.element.querySelector('#register .accountDrawer--ErrorSpace');
            if (!errorElem) return alert(tempDiv.querySelector('.registerErrors').innerHTML);

            errorElem.innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;

          } else {
            
            location.href = window.routes.account_url;
          }
    
         /* event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible');*/
    
    
        } catch (error) {
          console.log('An error occurred during the registration request:', error);
        }
      })();
    }

    openRecover() {
        event.preventDefault();
        this.recoveryForm.setAttribute('aria-hidden','false');
        this.loginForm.setAttribute('aria-hidden','true');

    }
    openLogin() {
        event.preventDefault();
        this.recoveryForm.setAttribute('aria-hidden','true');
        this.loginForm.setAttribute('aria-hidden','false');

    }

}
customElements.define("customer-login", Login);


class AccountComponent extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      
      new Popup(this.element);
  
      this.accountHeader = this.element.querySelector('.customerAccount--Header');
    
      this.bindEvents();
      this.handleRefreshState();
  
    }
    bindEvents(){
      this.delegateElement.on(
        'click',
        '[data-action="handle-pagination"]',
        this.handlePagination.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-subtab"]',
        this.toggleSubTab.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-tab"]',
        this.toggleTab.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-back"]',
        this.toggleBack.bind(this)
      );
      this.delegateElement.on(
        'click',
        '[data-action="delete-address"]',
        this.deleteAddress.bind(this)
      );

    
  
  }

  handlePagination(event, target){
      event.preventDefault();
      const contentContainer = this.element.querySelector('#activeOrders');
      const pagination = this.element.querySelector('#ordersPagination')
      
      
      if (event.target.tagName === 'A') {
        event.preventDefault();

        const desiredPage = event.target.getAttribute('href');
  
        fetch(window.routes.localeRootUrl + `${desiredPage}`)
        .then(response => response.text())
        .then(data => {
          const parseData = new DOMParser().parseFromString(data,'text/html');
         
           contentContainer.innerHTML = parseData.querySelector('#activeOrders').innerHTML; 
           pagination.innerHTML = parseData.querySelector('#ordersPagination').innerHTML;
        });
    
    
    }

  } 

  renderNewData(data){

  }

  handleRefreshState(){
    if (new Responsive().matchesBreakpoint('lap-and-up')) {
      this.element.querySelector('#contactInfo').setAttribute('aria-visible','true');
    }
        // Get the URL search parameters
        var searchParams = new URLSearchParams(window.location.search);

        // Get the value of param1
        var param1Value = searchParams.get('location');

        // Check if param1 has a value
        if (param1Value) {
          this.toggleTab(false, param1Value);
        }
  }
  
  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute("data-id");
  
    Shopify.postLink("/account/addresses/" + id, {
        parameters: { _method: "delete" },
    });
  }
  
  toggleBack(){
    const menuTab = this.element.querySelector('.customerAccount--Menu');
    menuTab.style.display = "flex";
    this.accountHeader.style.display = "block";
  
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    allContent.forEach((content) => {
      if(content.id == "activeOrders" || content.id == "orderHistory") return;
      content.setAttribute('aria-visible', 'false');
    });
  }
  
  toggleTab(event, paramValue){
      let id = paramValue;
    if (event){
       id = event.target.dataset.id;
    }
   
    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    const menuTab = this.element.querySelector('.customerAccount--Menu');
  

    if (new Responsive().matchesBreakpoint('pocket')) {
      this.accountHeader.style.display = "none";
      menuTab.style.display = "none";
    }


    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
    if (event){
      event.target.setAttribute('aria-expanded', 'true');
    } else {
      this.element.querySelector(`[data-id="${id}"]`).setAttribute('aria-expanded', 'true');
    }

  
    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')){
        content.setAttribute('aria-visible', 'false');
      }

    });
  
    const content = this.element.querySelector(`#${id}`);
    
    if (content) {
      content.setAttribute('aria-visible', 'true');
      


    } 
    

 // Get the current URL
var currentUrl = window.location.href;

// Create a new URL with updated search parameters
var newUrl = currentUrl.split('?')[0] + `?location=${id}`;

// Modify the URL without refreshing the page
window.history.pushState({ path: newUrl }, '', newUrl);

  }

    
  toggleSubTab(event){

    const id = event.target.dataset.id;
   
    
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');

  
 
    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });
  
    event.target.setAttribute('aria-expanded', 'true');
  
    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });
  
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    } 
  }
  }
  
  
  customElements.define("account-component-inner", AccountComponent);